import { Component, OnInit, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { ModalService, ErrorTranslationService } from '@bayclubs/utils';
import { BayclubsAlertService } from '@bayclubs/alert';

import { campsenum } from '../../../../models/enums.generated';
import { ConfirmationReasonComponent } from '../confirmation-reason/confirmation-reason.component';
import { camps } from '../../../../models/models.generated';
import { CampsEnumTranslationService } from '../../../../services/camps-enum-translation.service';
import { CouponApiService } from '../../../../services/api/coupon-api.service';

@Component({
    selector: 'app-coupon-list-row',
    templateUrl: './coupon-list-row.component.html',
    styleUrls: ['./coupon-list-row.component.scss'],
    standalone: false
})
export class CouponListRowComponent implements OnInit {
    @Input() public item: camps.CouponInfo;

    public isMasked: boolean = true;

    constructor(
        private translate: TranslateService,
        private enumTranslations: CampsEnumTranslationService,
        private api: CouponApiService,
        private alert: BayclubsAlertService,
        private modal: ModalService,
        private errorTranslate: ErrorTranslationService
    ) {}

    ngOnInit() {}

    public onActivate(event: Event): void {
        this.stopEvent(event);

        this.modal
            .create<ConfirmationReasonComponent>(ConfirmationReasonComponent, {
                code: this.item.code,
                confirmationText: this.translate.instant('ConfirmationReason.ActivateQuestion'),
                confirmButtonText: this.translate.instant('ConfirmationReason.YesActivate')
            })
            .subscribe(x => {
                if (x.isConfirmed) {
                    this.api.activate(<camps.CouponActivateRequest>{ id: this.item.id, reason: x.reason }).subscribe(x => {
                        if (x.isSuccess) {
                            this.item = x.value;
                            this.alert.showOperationSuccess();
                        } else {
                            this.errorTranslate.translateValidationNotifications(x.validationNotification);
                            this.alert.showError(x.validationNotification.errors[0].message);
                        }
                    });
                }
            });
    }

    public onDeactivate(event: Event): void {
        this.stopEvent(event);

        this.modal
            .create<ConfirmationReasonComponent>(ConfirmationReasonComponent, {
                code: this.item.code,
                confirmationText: this.translate.instant('ConfirmationReason.DeactivateQuestion'),
                confirmButtonText: this.translate.instant('ConfirmationReason.YesDeactivate')
            })
            .subscribe(x => {
                if (x.isConfirmed) {
                    this.api.deactivate(<camps.CouponDeactivateRequest>{ id: this.item.id, reason: x.reason }).subscribe(x => {
                        if (x.isSuccess) {
                            this.item = x.value;
                            this.alert.showOperationSuccess();
                        } else {
                            this.errorTranslate.translateValidationNotifications(x.validationNotification);
                            this.alert.showError(x.validationNotification.errors[0].message);
                        }
                    });
                }
            });
    }

    public onCodeClick(event) {
        var selection = window.getSelection();
        if (selection.toString().length > 0) {
            this.stopEvent(event);
        }
    }

    public translateStatus(item: camps.CouponInfo): string {
        if (item.status == campsenum.CouponStatus.Created && item.isExpired) {
            return this.translate.instant('CouponsList.ExpiredStatus');
        }

        return this.enumTranslations.couponStatus(item.status);
    }


    public translateUsageType(item: camps.CouponInfo){
        return this.enumTranslations.couponUsageType(item.usageType);
    }

    public translateType(item: camps.CouponInfo): string {
        return this.enumTranslations.couponType(item.type);
    }

    public get showActivate() {
        return this.item.status == campsenum.CouponStatus.Deactivated;
    }

    public get showDeactivate() {
        return this.item.status == campsenum.CouponStatus.Created;
    }

    public onToggleViewCoupon(event: Event) {
        this.stopEvent(event);

        this.isMasked = !this.isMasked;
    }

    public onUnmask() {
        this.isMasked = false;
    }

    public onMask() {
        this.isMasked = true;
    }

    public get code() {
        if (this.isMasked) {
            return (this.item.code && this.item.code.length > 3) ? this.item.code.replace(/[a-zA-Z0-9]{3}$/g, '....') : '...';
        } else {
            return this.item.code;
        }
    }

    public get isAmount(): boolean {
        return this.item.type == campsenum.CouponType.Amount;
    }

    public get isWeeks(): boolean {
        return this.item.type == campsenum.CouponType.FreeWeeks;
    }

    public get isDays(): boolean {
        return this.item.type == campsenum.CouponType.FreeDays;
    }

    public get isPercent(): boolean {
        return this.item.type == campsenum.CouponType.Percentage;
    }

    private stopEvent(event: Event) {
        event.preventDefault();
        event.stopPropagation();
    }
}
